import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Drawer,
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress
} from "@mui/material";
import PaginationComp from "../../Pagination/PaginationComp";
import baseUrl from "../../config/baseUrl";
import axios from "axios";
import Popover from "@mui/material/Popover";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import TeamsPermission from "./TeamsPermission";

const TeamsTable = ({
  merchant,
  message,
  page,
  totalPage,
  setPage,
  auth,
  ReadData,
  authRead,
  authDelete,
  authUpdate,
  loading
}) => {
  const toggleStatus = async (id, status) => {
    try {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("status", status);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/toggleSubAdmin`,
        formData,
        config
      );
      //   toast.success(result.data.message, {
      //     position: "bottom-right",
      //     autoClose: 1000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
      ReadData();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto", marginTop: "16px", scrollbarWidth: "none", "-ms-overflow-style": "none"}}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" my={3}>
            <CircularProgress sx={{color: "#ff6600"}} />
          </Box>
        ) : (
          <Table
            stickyHeader
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
              "& th, & td": {
                padding: "10px 12px",
                fontSize: "13.5px",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#f1f5f9",
                position: "sticky",
                top: 0,
                zIndex: 1,
                "& th": {
                  fontWeight: 600,
                  color: "#1f2937",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "#f1f5f9",
                  whiteSpace: 'nowrap'
                },
              }}
            >
              <TableRow>
                {[
                  "Employee",
                  "Name",
                  "Email",
                  "Phone",
                  "Role",
                  "Created On",
                  "Action",
                ].map((heading) => (
                  <TableCell key={heading}>
                    <Typography
                      color="textPrimary"
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", textTransform: "uppercase", textAlign: "center", }}
                    >
                      {heading}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {merchant.map((merchant, index) => (
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    "&:hover": {
                      backgroundColor: "#f1f1f1",
                    },
                  }}
                >
                  <TableCell>
                    <Typography variant="h6" sx={{textAlign: "center",}}>
                      <span style={{ color: "#ff9800" }}>
                        #EMP{merchant.id}
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" sx={{textAlign: "center",}}>{merchant.name}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" sx={{textAlign: "center",}}>{merchant.email}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" sx={{textAlign: "center",}}>{merchant.mobile_no}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        color:
                          merchant.usercode === "1"
                            ? "red"
                            : merchant.usercode === "2"
                            ? "green"
                            : merchant.usercode === "3"
                            ? "orange"
                            : "blue",
                        textTransform: "uppercase",
                      }}
                      variant="h6"
                    >
                      {merchant.usercode === "1"
                        ? "ADMINISTRATOR"
                        : merchant.usercode === "2"
                        ? "MANAGER"
                        : merchant.usercode === "3"
                        ? "CASHIER"
                        : "REPORTER"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" style={{ textAlign: "center" }}>
                      {merchant.created_on}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <PopUp
                      item={merchant}
                      authRead={authRead}
                      ReadData={ReadData}
                      authUpdate={authUpdate}
                      authDelete={authDelete}
                    />
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={12} align="center">
                  
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <PaginationComp
        setPage={setPage}
        page={page}
        totalPage={totalPage}
        message={message}
        disabled={loading}
      />
    </>
  );
};

const PopUp = ({item, authUpdate, authDelete, ReadData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
  
    const deleteRow = async (id) => {
      try {
        const auth = sessionStorage.getItem("user");
        let answer = window.confirm("Are you sure you want to delete this?");
        if (answer) {
          let formData = new FormData();
          formData.append("id", id);
  
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              Authorization: `Bearer ${auth}`,
            },
          };
  
          let result = await axios.post(
            `${baseUrl}/deleteSubAdmin`,
            formData,
            config
          );
          window.location.reload();
          ReadData()
        }
      } catch (error) {
        console.log(error);
      }
    };
    return (
      <>
        <div>
          <IconButton
            aria-label="menu"
            color="inherit"
            aria-controls="dd-menu"
            aria-haspopup="true"
            onClick={handleClick}
            sx={{
              "&:hover": {
                backgroundColor: 'transparent', 
              },
            }}
          >
            <AddToPhotosOutlinedIcon />
          </IconButton>
  
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
            PaperProps={{
              style: { width: "150px", zIndex: 1 },
            }}
            sx={{
              zIndex: 1
            }}
          >
  
          <div className="d-flex  align-items-center justify-content-around flex-column">
            {
              authUpdate ? (
                <EditDrawer item={item} authUpdate={authUpdate} />
              ) : null
            }
  
            <TeamsPermission ID={item.id} />
  
            {authDelete ? (
              <button
                className="btn btn-danger mt-3 mb-3 btn-sm" style={{width: "90px"}}
                onClick={() => deleteRow(item.user_id)}
              >
                Delete
              </button>
            ) : null}
          </div>
            
          </Popover>
        </div>
      </>
    );
};

const EditDrawer = ({ item, authUpdate }) => {
    const [state, setState] = useState({ right: false });
  
    const [formState, setFormState] = useState({
        fname: item.fname,
        lname: item.lname,
        usercode: item.usercode,
        email: item.email,
        mobile_no: item.mobile_no,
    });

    const roleOptions = [
        { label: "Administrator", value: 1 },
        { label: "Manager", value: 2 },
        { label: "Cashier", value: 3 },
        { label: "Reporter", value: 4 },
    ];
  
    const auth = sessionStorage.getItem("user");
  
    const roleDescriptions = {
      1: "Administrator\nFull access to UBank Connect. This role allows the same permissions as the Owner, but does not allow access to Owner information. The Admin role should only be assigned to your most trusted and senior employees only.",
      2: "Manager\nLimited access to employee operations and reports. This role should be assigned to mid-level managers who need access to team data but not system-level settings.",
      3: "Cashier\nThis role allows access to perform transactions, manage customer payments, and generate receipts. Cashiers cannot modify system settings or access user data.",
      4: "Reporter\nRead-only access to dashboards, reports, and analytics. Reporters can view but not modify or initiate any operations. Suitable for auditors or oversight personnel."
    };
  
    const toggleDrawer = (open) => () => {
      setState({ right: open });
      if (open) {
        // console.log(item)
      } else {
        window.location.reload();
      }
    };
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();  
      try {
        const values = {
          id: item.id,
          fname: formState.fname,
          lname: formState.lname,
          email: formState.email,
          usercode: formState.usercode,
          mobile_no: formState.mobile_no,
        };
  
        const config = {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${auth}`,
          },
        };
  
        const result = await axios.post(`${baseUrl}/teamEditDetails`, values, config);
  
        if (result.status === 200) {
          alert(result.data.message);
          toggleDrawer(false)();
          window.location.reload();
        } else {
          alert(result.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    return (
      <>
        {authUpdate && (
          <button
              className="btn btn-success mt-3 btn-sm"
              style={{ width: "90px" }}
              onClick={toggleDrawer(true)}
          >
              Edit
          </button>
        )}
  
        <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)} PaperProps={{ style: { zIndex: 3 }, }}>
          <Box sx={{ width: { xs: 300, sm: 500 } }} role="presentation">
            <div style={{ padding: '20px', position: 'relative' }}>
              <h4>EDIT EMPLOYEE</h4>
              <button
                style={{
                  position: 'absolute',
                  top: '22px',
                  right: '10px',
                  background: '#ff6600',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  padding: '5px',
                  width: '25px',
                  height: '25px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={toggleDrawer(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
  
              <form onSubmit={handleSubmit}>
                <TextField
                  label="First Name"
                  fullWidth
                  margin="normal"
                  name="fname"
                  value={formState.fname}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Last Name"
                  fullWidth
                  margin="normal"
                  name="lname"
                  value={formState.lname}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Email"
                  fullWidth
                  margin="normal"
                  type="email"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Phone Number"
                  fullWidth
                  margin="normal"
                  name="mobile_no"
                  value={formState.mobile_no}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <FormControl fullWidth margin="normal">
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Select
                        labelId="role-select-label"
                        value={formState.usercode}
                        name="usercode"
                        label="Role"
                        onChange={handleChange}
                        InputProps={{
                          style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                        }}
                    >
                        {roleOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {formState.usercode && (
                    <Box sx={{ mt: 1, backgroundColor: '#f9f9f9', p: 2, borderRadius: '8px' }} InputProps={{ style: { zIndex: 4}}}>
                        <Typography variant="subtitle2" gutterBottom>
                        Description
                        </Typography>
                        <Typography variant="body2" color="textSecondary" whiteSpace="pre-line">
                        {roleDescriptions[formState.usercode]}
                        </Typography>
                    </Box>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ marginTop: '20px' }}
                >
                  Save Changes
                </Button>
              </form>
            </div>
          </Box>
        </Drawer>
      </>
    );
};
  

export default TeamsTable;
